module.exports = __webpack_public_path__ + "static/media/Kevin Morse VPMA_1585002071501.3a0a7f15.png";